import { testIds } from '@/services/testAutomation';

export const sharedToasterConfigs = {
  timeout: 3000,
  position: 'topCenter',
  id: testIds.toaster.error,
  wrapperClass: 'toaster-center-wrapper',
};

export const errorToasterConfigs: any = {
  ...sharedToasterConfigs,
  id: testIds.toaster.error,
};

export const successToasterConfigs: any = {
  ...sharedToasterConfigs,
  id: testIds.toaster.success,
};
